import React from "react";
import HeroSection from "../Components/home/HeroSection";
import WelcomeSection from "../Components/home/WelcomeSection";
import QuickLinks from "../Components/home/QuickLinks";
import UpcomingEvents from "../Components/home/UpcomingEvents";
import DonationCTA from "../Components/home/DonationCTA";

export default function Home() {
  return (
    <div className="font-sans-clean">
      <HeroSection />
      <WelcomeSection />
      <QuickLinks />
      <UpcomingEvents />
      <DonationCTA />
    </div>
  );
}
